import { render, staticRenderFns } from "./SustSidebar.vue?vue&type=template&id=2a363ffa&scoped=true"
import script from "./SustSidebar.vue?vue&type=script&lang=js"
export * from "./SustSidebar.vue?vue&type=script&lang=js"
import style0 from "./SustSidebar.vue?vue&type=style&index=0&id=2a363ffa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a363ffa",
  null
  
)

export default component.exports